import type { ReactNode } from 'react';

// Icons als Inline-SVG: eigene Strichzeichnungen in currentColor – Farbe und Größe kommen vom umgebenden Element
// (in der roten Markenleiste weiß). Rein dekorativ; die Beschriftung trägt das Element daneben bzw. aria-label.
export type IconName =
  | 'bell'
  | 'menu'
  | 'phone'
  | 'smartphone'
  | 'calendar'
  | 'calendarX'
  | 'clock'
  | 'check'
  | 'sparkle'
  | 'pin'
  | 'dot'
  | 'plus'
  | 'message'
  | 'mail'
  | 'note'
  | 'ban'
  | 'award'
  | 'lock'
  | 'user'
  | 'edit'
  | 'warning'
  | 'route'
  | 'help'
  | 'home'
  | 'navigate'
  | 'chart'
  | 'map'
  | 'mic'
  | 'send'
  | 'close';

const shapes: Record<IconName, ReactNode> = {
  bell: (
    <>
      <path d="M12 3v2" />
      <path d="M5 17h14l-1.6-2.1a2 2 0 0 1-.4-1.2V10a5 5 0 0 0-10 0v3.7a2 2 0 0 1-.4 1.2L5 17z" />
      <path d="M10 19.5a2 2 0 0 0 4 0" />
    </>
  ),
  menu: <path d="M4 6.5h16M4 12h16M4 17.5h16" />,
  phone: <path d="M3.5 5.5A16.5 16.5 0 0 0 18.5 20.5l1.9-1.3.6-2.8-4.4-2.3-2.5 1.3A12.8 12.8 0 0 1 8.6 9.9l1.3-2.5L7.6 3l-2.8.6z" />,
  smartphone: (
    <>
      <rect x="7" y="2.5" width="10" height="19" rx="2" />
      <path d="M11 18h2" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </>
  ),
  calendarX: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M3.5 10h17M8 3v4M16 3v4M10 13.5l4 4M14 13.5l-4 4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  sparkle: <path d="M12 3l2 7 7 2-7 2-2 7-2-7-7-2 7-2z" />,
  mic: (
    <>
      <rect x="9" y="3.5" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0" />
      <path d="M12 17.5V21" />
    </>
  ),
  send: (
    <>
      <path d="M4 12l16-8-6 16-2.5-6.5z" />
      <path d="M11.5 13.5L20 4" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  pin: (
    <>
      <path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z" />
      <circle cx="12" cy="10" r="2.3" />
    </>
  ),
  dot: <circle cx="12" cy="12" r="2.5" />,
  plus: <path d="M12 5v14M5 12h14" />,
  message: <path d="M5 5h14a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 19 17h-8l-4.5 3.5V17H5a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 5 5z" />,
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="1.5" />
      <path d="M4 7l8 6 8-6" />
    </>
  ),
  note: (
    <>
      <path d="M6.5 3.5h7.5l4 4v13h-11.5z" />
      <path d="M14 3.5v4h4M9.5 12h5M9.5 15.5h5" />
    </>
  ),
  ban: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M6 6l12 12" />
    </>
  ),
  award: (
    <>
      <circle cx="12" cy="9" r="5.5" />
      <path d="M8.5 13.5L7 21l5-2.5 5 2.5-1.5-7.5" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10.5" width="14" height="10" rx="1.5" />
      <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="3.8" />
      <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" />
    </>
  ),
  edit: <path d="M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4" />,
  warning: (
    <>
      <path d="M12 4l9.5 16h-19z" />
      <path d="M12 10v4.5M12 17.5h.01" />
    </>
  ),
  route: (
    <>
      <circle cx="6" cy="18" r="2" />
      <circle cx="18" cy="6" r="2" />
      <path d="M8 18h6.5a3.5 3.5 0 0 0 0-7h-5a3.5 3.5 0 0 1 0-7H16" />
    </>
  ),
  help: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M9.6 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .9-1 1.6v.4M12 17h.01" />
    </>
  ),
  home: <path d="M4 11 12 4.5l8 6.5v8.5a1 1 0 0 1-1 1h-4.5v-5.5h-5V20.5H5a1 1 0 0 1-1-1z" />,
  navigate: <path d="M12 3.5l6.5 16.5-6.5-3.7L5.5 20z" />,
  chart: <path d="M4.5 19.5h15M7 16.5v-5M11 16.5V7.5M15 16.5v-7M19 16.5V5" />,
  map: <path d="M3.5 6.5 9 4.5l6 2 5.5-2v13l-5.5 2-6-2-5.5 2zM9 4.5v13M15 6.5v13" />,
};

export function Icon({ name, size = 18 }: { name: IconName; size?: number }) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {shapes[name]}
    </svg>
  );
}
